/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BulkUpdateFacilityServiceAreasResponse } from './BulkUpdateFacilityServiceAreasResponse';
import {
    BulkUpdateFacilityServiceAreasResponseFromJSON,
    BulkUpdateFacilityServiceAreasResponseFromJSONTyped,
    BulkUpdateFacilityServiceAreasResponseToJSON,
    BulkUpdateFacilityServiceAreasResponseToJSONTyped,
} from './BulkUpdateFacilityServiceAreasResponse';

/**
 * 
 * @export
 * @interface BulkUpdateFacilityServiceAreas200Response
 */
export interface BulkUpdateFacilityServiceAreas200Response {
    /**
     * 
     */
    data?: BulkUpdateFacilityServiceAreasResponse;
}

/**
 * Check if a given object implements the BulkUpdateFacilityServiceAreas200Response interface.
 */
export function instanceOfBulkUpdateFacilityServiceAreas200Response(value: object): value is BulkUpdateFacilityServiceAreas200Response {
    return true;
}

export function BulkUpdateFacilityServiceAreas200ResponseFromJSON(json: any): BulkUpdateFacilityServiceAreas200Response {
    return BulkUpdateFacilityServiceAreas200ResponseFromJSONTyped(json, false);
}

export function BulkUpdateFacilityServiceAreas200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateFacilityServiceAreas200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : BulkUpdateFacilityServiceAreasResponseFromJSON(json['data']),
    };
}

export function BulkUpdateFacilityServiceAreas200ResponseToJSON(json: any): BulkUpdateFacilityServiceAreas200Response {
    return BulkUpdateFacilityServiceAreas200ResponseToJSONTyped(json, false);
}

export function BulkUpdateFacilityServiceAreas200ResponseToJSONTyped(value?: BulkUpdateFacilityServiceAreas200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BulkUpdateFacilityServiceAreasResponseToJSON(value['data']),
    };
}

